import React from 'react';
import { useParams } from 'react-router-dom';
import './blog1.css'

const BlogPost1 = () => {
    const { id } = useParams();

    const blogPost = {
        id: 1,
        title: "The Sustainable Shift: Why Paper Bags Are Making a Comeback",
        date: new Date(),
        category: "Sustainability",
        readTime: "4 min read",
        mainImage: "/assets/bg/blog1-banner.jpg",
        content: [
            {
                type: 'paragraph',
                content: 'In recent years, there has been a significant shift in consumer consciousness towards sustainable packaging solutions. Paper bags, once considered a simple alternative to plastic, are now at the forefront of the eco-friendly packaging revolution.'
            },
            {
                type: 'heading',
                content: 'The Environmental Impact'
            },
            {
                type: 'paragraph',
                content: 'Paper bags are biodegradable, recyclable, and made from renewable resources. Unlike their plastic counterparts, they break down naturally within weeks to months, leaving minimal environmental impact. Studies show that a single paper bag can be reused multiple times and recycled up to seven times before the fibers become too short for further use.'
            },
            {
                type: 'image',
                url: '/assets/blogs/blog1-post-image.jpg',
                caption: 'Sustainable paper bag production process'
            },
            {
                type: 'quote',
                content: 'The choices we make today about packaging will shape the environment our children inherit tomorrow.',
                author: 'Environmental Protection Agency'
            },
            {
                type: 'heading',
                content: 'Innovation in Paper Bag Design'
            },
            {
                type: 'paragraph',
                content: 'Modern paper bags are far from the flimsy carriers of the past. Advanced manufacturing techniques have resulted in stronger, more durable bags that can handle substantial weights. Water-resistant treatments and reinforced handles have made them practical for various uses, from grocery shopping to luxury retail.'
            }
        ],
        tags: ["Sustainability", "Eco-Friendly", "Packaging", "Environment", "Green Living"]
    };

    const formatDate = (date) => {
        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }).format(date);
    };

    return (
        <div className="blog-detail">
            <div className="blog-hero">
                <img 
                    src={blogPost.mainImage} 
                    alt={blogPost.title} 
                    className="hero-image"
                />
                <div className="hero-overlay"></div>
                <div className="container">
                    <div className="blog-post-content">
                        <div className="meta">
                            <span className="category">{blogPost.category}</span>
                            <span className="separator">•</span>
                            <span className="read-time">{blogPost.readTime}</span>
                        </div>
                        <h1 className="title">{blogPost.title}</h1>
                        <div className="publish-date">{formatDate(blogPost.date)}</div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-8">
                        <article className="blog-content">
                            {blogPost.content.map((block, index) => {
                                switch (block.type) {
                                    case 'paragraph':
                                        return <p key={index}>{block.content}</p>;
                                    case 'heading':
                                        return <h2 key={index}>{block.content}</h2>;
                                    case 'image':
                                        return (
                                            <figure key={index} className="image-block">
                                                <img src={block.url} alt={block.caption} />
                                                {block.caption && (
                                                    <figcaption>{block.caption}</figcaption>
                                                )}
                                            </figure>
                                        );
                                    case 'quote':
                                        return (
                                            <blockquote key={index}>
                                                <p>{block.content}</p>
                                                {block.author && (
                                                    <cite>— {block.author}</cite>
                                                )}
                                            </blockquote>
                                        );
                                    default:
                                        return null;
                                }
                            })}
                        </article>

                        <div className="tags">
                            {blogPost.tags.map((tag, index) => (
                                <span key={index} className="tag">#{tag}</span>
                            ))}
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="sidebar">
                            <div className="sidebar-widget">
                                <h3>Popular Tags</h3>
                                <div className="tag-cloud">
                                    {blogPost.tags.map((tag, index) => (
                                        <a key={index} href="#" className="tag">
                                            {tag}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogPost1;